var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"my-2",attrs:{"nuxtlink":"","link":"/investing/services/ivestor"}},[_vm._v(_vm._s(_vm.$t('global.buttons.ivestorApp')))])
}
var staticRenderFns = []

export { render, staticRenderFns }